/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 08.05.2015
 *   Time: 17:49
 */

import { IFormat } from "../api/IFormat";
import { TimeType } from "../../utils/time/TimeType";

/**
 * @private
 *
 * TODO agoncharov: generalize and move to utils
 * TODO agoncahrov: implement all defined options
 *
 * Format:
 *
 * format_spec  ::=  [[fill]align][sign][#][0][width][.precision][type]
 * fill         ::=  &lt;a character other than '}'&gt;
 * align        ::=  "&lt;" | "&gt;" | "=" | "^"
 * sign         ::=  "+" | "-" | " "
 * width        ::=  integer
 * precision    ::=  integer
 * type         ::=  "b" | "c" | "d" | "e" | "E" | "f" | "F" | "g" | "G" | "n" | "o" | "x" | "X" | "%"
 */
export class InlineDurationFormat implements IFormat {
    // tslint:disable-next-line:max-line-length
    private static REGEXP_FORMAT: RegExp = /(?:(.)?(<|>|=|^){1})?(\+|-)?(0)?(\d+)?(?:\.(\d+))?(b|c|d|e|E|f|F|g|G|n|o|x|X|%)?/; // /((?P<fill>.)?(?P<align><|>|=|^){1})?(?P<sign>\+|-)?(?P<zero>0)?(?P<width>\d+)?(\.(?P<precision>\d+))?(?P<type>b|c|d|e|E|f|F|g|G|n|o|x|X|%)?/
    private static REGEXP_FORMAT_GROUP_FILL = 1;
    private static REGEXP_FORMAT_GROUP_ALIGN = 2;
    private static REGEXP_FORMAT_GROUP_SIGN = 3;
    private static REGEXP_FORMAT_GROUP_ZERO = 4;
    private static REGEXP_FORMAT_GROUP_WIDTH = 5;
    private static REGEXP_FORMAT_GROUP_PRECISION = 6;
    private static REGEXP_FORMAT_GROUP_TYPE = 7;

    private static REGEXP_NUMBER: RegExp = /(\d+)(?:\.(\d+))?/; // /(?P<integer>\d+)(\.(?P<fraction>\d+))?/
    private static REGEXP_NUMBER_GROUP_INTEGER = 1;
    private static REGEXP_NUMBER_GROUP_FRACTION = 2;

    private static TYPE_DECIMAL: any[] = ["d"];
    private static TYPE_FLOAT: any[] = ["f", "F"];

    private _fill: string;
    private _align: string;
    private _sign: string;
    private _precision: string;
    private _width: string;
    private _type: string;

    // tslint:disable-next-line:no-empty
    constructor() {}

    public parse(format: string): InlineDurationFormat {
        if (format && format.length !== 0) {
            let parts: any[] = format.match(InlineDurationFormat.REGEXP_FORMAT);

            if (parts == null) {
                throw new Error("format:" + format);
            }

            this._fill = parts[InlineDurationFormat.REGEXP_FORMAT_GROUP_FILL] || parts[InlineDurationFormat.REGEXP_FORMAT_GROUP_ZERO] || "";
            this._align = parts[InlineDurationFormat.REGEXP_FORMAT_GROUP_ALIGN];
            this._sign = parts[InlineDurationFormat.REGEXP_FORMAT_GROUP_SIGN];
            this._precision = parts[InlineDurationFormat.REGEXP_FORMAT_GROUP_PRECISION];
            this._width = parts[InlineDurationFormat.REGEXP_FORMAT_GROUP_WIDTH];
            // tslint:disable-next-line:max-line-length
            this._type =
                parts[InlineDurationFormat.REGEXP_FORMAT_GROUP_TYPE] ||
                (this._precision ? InlineDurationFormat.TYPE_FLOAT[0] : InlineDurationFormat.TYPE_DECIMAL[0]);
        } else {
            this._fill = undefined;
            this._align = undefined;
            this._sign = undefined;
            this._precision = undefined;
            this._width = undefined;
            this._type = InlineDurationFormat.TYPE_DECIMAL[0];
        }

        return this;
    }

    public apply(getText: Function, values: number[], index: number): string {
        let value: number = values[index];
        let result: string = String(value);
        let types: TimeType[] = TimeType.values;

        if (InlineDurationFormat.TYPE_FLOAT.indexOf(this._type) !== -1) {
            // time related precision
            if (this._precision && index !== 0) {
                let rate: number = types[index].milliseconds / types[index - 1].milliseconds;
                result = (value + values[index - 1] / rate).toFixed(parseFloat(this._precision));
            }

            const float: any[] = result.match(InlineDurationFormat.REGEXP_NUMBER);
            const integer: string = float[InlineDurationFormat.REGEXP_NUMBER_GROUP_INTEGER];
            const fraction: string = float[InlineDurationFormat.REGEXP_NUMBER_GROUP_FRACTION];

            result = integer + (fraction.length ? getText("generic_comma") + fraction : "");
        }

        if (this._width) {
            let width: number = Number(this._width);
            let diff: number = width - result.length;

            while (diff-- > 0) {
                result = this._fill + result;
            }
        }

        return result;
    }

    public get width(): string {
        return this._width;
    }

    public set width(value: string) {
        this._width = value;
    }

    public get fill(): string {
        return this._fill;
    }

    public set fill(value: string) {
        this._fill = value;
    }

    public get precision(): string {
        return this._precision;
    }

    public set precision(value: string) {
        this._precision = value;
    }

    public get type() {
        return this._type;
    }
}
